import { NextSeo, NextSeoProps } from 'next-seo';

export const Seo = ({ nofollow, noindex, ...props }: NextSeoProps) => {
  const indexingEnabled = !!process.env.NEXT_PUBLIC_INDEXING_ENABLED;

  const nofollowOverride = indexingEnabled ? nofollow : true;
  const noindexOverride = indexingEnabled ? noindex : true;

  return (
    <NextSeo nofollow={nofollowOverride} noindex={noindexOverride} {...props} />
  );
};

export default Seo;
